// ══════════════════════════════════════════════════════════
// Utilidad para crear menú contextual con Escape
// ══════════════════════════════════════════════════════════

import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '../config/Constants';

export function createEscapeMenu(scene: Phaser.Scene, onResume: () => void, onExit: () => void): () => void {
  const keyEsc = scene.input.keyboard?.addKey(Phaser.Input.Keyboard.KeyCodes.ESC);
  let overlay: Phaser.GameObjects.GameObject[] = [];
  let isOpen = false;

  const toggleMenu = () => {
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  const openMenu = () => {
    if (isOpen) return;
    isOpen = true;
    scene.scene.pause(); // pausa la escena actual

    // Crear overlay en una nueva escena "encima"
    const escene = scene.scene.get('EscapeMenuScene');
    if (escene) {
      scene.scene.launch('EscapeMenuScene', { onResume, onExit, parentScene: scene.scene.key });
    } else {
      // Fallback: menú básico con graphics
      createBasicEscapeMenu(scene, onResume, onExit, () => { isOpen = false; });
    }
  };

  const closeMenu = () => {
    isOpen = false;
    const escene = scene.scene.get('EscapeMenuScene');
    if (escene && escene.scene.isActive()) {
      scene.scene.stop('EscapeMenuScene');
    }
    scene.scene.resume();
  };

  if (keyEsc) {
    keyEsc.on('down', toggleMenu);
  }

  return closeMenu;
}

function createBasicEscapeMenu(scene: Phaser.Scene, onResume: () => void, onExit: () => void, onClose: () => void): void {
  const bg = scene.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, 0x000000, 0.8)
    .setInteractive().setDepth(1000);

  const panelBg = scene.add.graphics().setDepth(1001);
  panelBg.fillStyle(0x1a1a3e, 0.95);
  panelBg.fillRoundedRect(GAME_WIDTH / 2 - 200, GAME_HEIGHT / 2 - 150, 400, 300, 16);
  panelBg.lineStyle(2, 0x3498db, 0.6);
  panelBg.strokeRoundedRect(GAME_WIDTH / 2 - 200, GAME_HEIGHT / 2 - 150, 400, 300, 16);

  scene.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 120, '⏸  MENÚ', {
    fontSize: '28px', color: '#ffffff', fontFamily: 'Arial Black',
  }).setOrigin(0.5).setDepth(1002);

  // Enlace web
  const linkText = scene.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 50, '🌐 luisjl.com', {
    fontSize: '20px', color: '#3498db', fontStyle: 'bold',
  }).setOrigin(0.5).setDepth(1002).setInteractive({ useHandCursor: true });
  linkText.on('pointerover', () => linkText.setColor('#5dade2'));
  linkText.on('pointerout', () => linkText.setColor('#3498db'));

  // Botón Continuar
  const contBg = scene.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 30, 260, 45, 0x27ae60, 0.9)
    .setStrokeStyle(2, 0x2ecc71).setDepth(1002).setInteractive({ useHandCursor: true });
  scene.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 30, '▶  CONTINUAR', {
    fontSize: '18px', color: '#ffffff', fontStyle: 'bold',
  }).setOrigin(0.5).setDepth(1003);

  // Botón Salir
  const exitBg = scene.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 90, 260, 45, 0xc0392b, 0.9)
    .setStrokeStyle(2, 0xe74c3c).setDepth(1002).setInteractive({ useHandCursor: true });
  scene.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 90, '🚪  SALIR AL MENÚ', {
    fontSize: '18px', color: '#ffffff', fontStyle: 'bold',
  }).setOrigin(0.5).setDepth(1003);

  const cleanup = () => {
    bg.destroy();
    panelBg.destroy();
    linkText.destroy();
    contBg.destroy();
    exitBg.destroy();
    scene.children.list.filter(c => c.type === 'Text' && (c as any).y > GAME_HEIGHT / 2 - 130).forEach(c => c.destroy());
    onClose();
  };

  bg.on('pointerdown', cleanup);
  contBg.on('pointerdown', cleanup);
  exitBg.on('pointerdown', () => {
    cleanup();
    onExit();
  });
}
